import { createSelector } from 'reselect';
import { keys, isEmpty } from 'lodash';

import { RootState } from 'store/reducers';

const stateAssets = (state: RootState): AssetsDTO => state.assets;

export const LayoutSelector = (state: RootState) => state.layout;

export const TransmortalAssetSelector = createSelector(
  [stateAssets],
  (state) => {
    const initObj = {
      id: '',
      documents: [] as DocumentDTO[],
      category: '',
      type: '',
    };

    return isEmpty(state) ? initObj : state?.['document']?.slice(-1)[0];
  }
);

export const AssetAssignmentsSelector = createSelector(
  [stateAssets],
  (state) => {
    const assetAssignments = {};

    keys(state).forEach((assetCategory) => {
      const categoryAssets: AssetDTO[] = state[assetCategory] || [];
      const isStepHasAllAssigned = !categoryAssets.some(
        (item) => isEmpty(item.contacts) && !item.notProvided
      );
      assetAssignments[assetCategory] = isStepHasAllAssigned;
    });

    return assetAssignments;
  }
);

export const AssetsNotAssignedSelector = createSelector(
  [stateAssets],
  (state) => {
    const assetAssignments = {};

    keys(state).forEach((assetCategory) => {
      const categoryAssets: AssetDTO[] = state[assetCategory] || [];
      const isHasNotAssigned = categoryAssets.some(
        (item) => isEmpty(item.contacts) && !item.notProvided
      );
      assetAssignments[assetCategory] = isHasNotAssigned;
    });

    return assetAssignments;
  }
);
